module.exports = __webpack_public_path__ + "img/CS-Lite_Overview-Rear_1.d0efd5b6.jpg";